<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar />
    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <v-row>
            <v-col>
                <v-btn @click="onSetTime">Set Time</v-btn>
                <v-btn v-if="userData.permissions.includes('calibrate_devices')" @click="$router.push('/calibrate/' + $route.params.id)">Calibrate</v-btn>
                <v-btn v-if="userData.permissions.includes('create_devices')" @click="$router.push('/usbdevicestatus/' + $route.params.id)">Real Time Device Status</v-btn>
                <v-btn v-if="userData.permissions.includes('create_devices')" @click="$router.push('/usbdevicetest/' + $route.params.id)">Testing</v-btn>
                <v-btn v-if="userData.permissions.includes('create_devices')" @click="$router.push('/viewflash/' + $route.params.id)">Flash Memory Inspector</v-btn>
                <v-btn v-if="userData.permissions.includes('create_devices')" @click="onFirmwareOpen">Apply Firmware File</v-btn>
                <input
                  type="file"
                  ref="firmwareOpenElem"
                  accept=".fwupd"
                  style="display:none;"
                  @change="openFirmware"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col style="max-width:300px;">
                <canvas id="lcd"
                        width="256" height="128"
                        style="float:left;width:276px;height:148px;border:5px solid black;padding:5px;border-radius:3px;background-color:rgba(181,206,177,1.0);">
                </canvas>
                <div v-if="usbFirmwareSize > 0">
                  <p>{{usbFirmwareSize}}</p>
                  <p>{{usbFirmwareProgress}}</p>
                </div>
            </v-col>
            <v-col>

                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>
                                Channel
                            </th>
                            <th>
                                Recording Enabled on Mains Power
                            </th>
                            <th>
                                Recording Enabled on Battery Power
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(statItem, statIndex) in deviceStatus">
                        <tr v-if="allowedBatteryChannels[statIndex] || allowedMainsChannels[statIndex]" :key="statItem[0]">
                            <td>
                                {{traceTitles[statItem[0]]}} ({{statItem[0]}}):
                            </td>
                            <td>
                              <v-checkbox
                                v-if="allowedMainsChannels[statIndex]"
                                v-model="enabledMainsChannels"
                                :value="1 << statIndex"
                                class="ma-0"
                                style="height:32px;width:32px;"
                                @change="onChannelsChanged"
                              ></v-checkbox>
                            </td>
                            <td>
                              <v-checkbox
                                v-if="allowedBatteryChannels[statIndex]"
                                v-model="enabledBatteryChannels"
                                :value="1 << statIndex"
                                class="ma-0"
                                style="height:32px;width:32px;"
                                @change="onChannelsChanged"
                              ></v-checkbox>
                            </td>
                        </tr>
                        </template>
                        <tr v-if="hasAflc">
                          <td>
                            AFLC Frequency Setting:
                          </td>
                          <td>
                            <v-form v-model="frequencyValid">
                            <v-text-field
                              v-model="config.aflcFreq"
                              style="width:80px;"
                              suffix="Hz"
                              :rules="validationRules.aflcFreq"
                              required
                              @change="onChannelsChanged"
                              @input="onChannelsChanged"
                            ></v-text-field>
                            </v-form>
                          </td>
                          <td>
                            (Bin {{config.aflcBin}})
                          </td>
                        </tr>
                        <tr v-if="channelsChanged">
                          <td colspan = "3" class="text-center">
                            <v-btn @click="saveChannels" style="width:300px;" color="primary" class="ma-2" :disabled="hasAflc && !frequencyValid">Save Changes to Logger</v-btn>
                            <v-btn @click="reloadChannels" style="width:300px;" color="error" class="ma-2">Cancel and Reload Channels</v-btn>
                          </td>
                        </tr>
                    </tbody>
                </v-simple-table>

            </v-col>
        </v-row>
        <v-row>

        </v-row>
        <usb-file-list :device="$route.params.id" @loadingStarted="onUsbLoadingStarted" @loadingComplete="onUsbLoadingComplete"></usb-file-list>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import usbRequest from '../mixins/usb-request';
import apiEndpoints from "../mixins/api-endpoints"



export default {
    mixins:[usbRequest, apiEndpoints],
  data() {
    return {
        usbLoading:false,
        config:{
          enabledMainsChannels:0,
          enabledBatteryChannels:0,
          allowedMainsChannels:0,
          allowedBatteryChannels:0,
        },
        deviceStatus:[],
        channelsChanged:false,
        frequencyValid:false,
        validationRules: {
          aflcFreq: [
            value => !!value || 'Required.',
            value => Number.isInteger(Number(value)) || 'Must be an integer.',
            value => parseInt(value) <= 2000 || 'Max 2000Hz',
            value => parseInt(value) >= 100 || 'Min 100Hz',
          ],
        },
    };
  },
  async mounted(){

    await this.usbGetFirmwareVersion();
    this.pollUsbDevice();

  },
  methods:{
    async reloadChannels(){
      this.config = await this.usbGetConfig();
      this.deviceStatus = await this.usbGetStatus();
      this.channelsChanged = false;
    },
    async saveChannels(){
      var result = await this.usbSetConfig(this.config)
      if (result !== false){
        this.channelsChanged = false;
        this.config = result;
      }
    },
    onUsbLoadingStarted(){
        this.usbLoading = true;
    },
    async onUsbLoadingComplete(){
        // once usb loading is complete,
        // load the config
        this.config = await this.usbGetConfig();
        this.deviceStatus = await this.usbGetStatus();
        this.usbLoading = false;
    },
    showError(message){
        this.$refs.errorBox.showError(message);
    },
    async displayLcd(){
        var cnv = document.getElementById("lcd");
        var ctx = cnv.getContext("2d");
        var imgData = await this.usbGetLcd(ctx);
        // this loop keeps the page notified that the logger is connected,
        // so if it fails, we go back to the previous page, which should be the
        // device selection page.
        if (imgData === false){
          return false;
        } else {
          ctx.putImageData(imgData, 0, 0);
          return true;
        }
    },
    async pollUsbDevice(){
        // only re-run the polling loop whilst we are on this route.
        if (this.$router.currentRoute.name == "usbdevice"){
            if (! this.usbLoading){
                if(await this.displayLcd() === false){
                  // displayLcd is async, so the route could have changed.
                  if (this.$router.currentRoute.name == "usbdevice"){
                    this.$router.go(-1);
                  }
                }
            }
            setTimeout(this.pollUsbDevice, 1000);
        }
    },
    onSetTime(){
        this.usbSetTime();
    },
    onChannelsChanged(){
      this.channelsChanged = true;
    },
    onFirmwareOpen(evt) {
      let fileInput = this.$refs.firmwareOpenElem;
      fileInput.click();
    },
    openFirmware(evt) {
      let fileInput = this.$refs.firmwareOpenElem;
      if (!fileInput.files) return;

      var file = fileInput.files[0];
      this.usbLoading = true;
      this.usbApplyFirmwareFile(file);
      this.usbLoading = false;

      fileInput.value = "";
    },
  },
  computed: {
    enabledMainsChannels: {
      // getter
      get: function() {
        var result = [];
        for (var i = 0; i < this.deviceStatus.length; i++){
          result.push (this.config.enabledMainsChannels & (1<<i));
        }
        return result;
      },
      // setter
      set: function(newValue) {
        this.config.enabledMainsChannels = newValue.reduce((total, num) => total + num);
      }
    },
    enabledBatteryChannels: {
      // getter
      get: function() {
        var result = [];
        for (var i = 0; i < this.deviceStatus.length; i++){
          result.push (this.config.enabledBatteryChannels & (1<<i));
        }
        return result;
      },
      // setter
      set: function(newValue) {
        this.config.enabledBatteryChannels = newValue.reduce((total, num) => total + num);
      }
    },

    allowedMainsChannels: {
      // getter
      get: function() {
        var result = [];
        for (var i = 0; i < this.deviceStatus.length; i++){
          result.push (this.config.allowedMainsChannels & (1<<i));
        }
        return result;
      },
      // setter
      set: function(newValue) {
        this.config.allowedMainsChannels = newValue.reduce((total, num) => total + num);
      }
    },
    allowedBatteryChannels: {
      // getter
      get: function() {
        var result = [];
        for (var i = 0; i < this.deviceStatus.length; i++){
          result.push (this.config.allowedBatteryChannels & (1<<i));
        }
        return result;
      },
      // setter
      set: function(newValue) {
        this.config.allowedBatteryChannels = newValue.reduce((total, num) => total + num);
      }
    },
    hasAflc(){
      let afIndex = this.deviceStatus.findIndex((val)=>val[0] == 'AFA');
      return (this.config.allowedMainsChannels & (1 << afIndex)) > 0;
    }
  },
};
</script>
